import React from "react";
import { iconProps } from "../../../../Helper";

export const GenerateIconIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clip-path="url(#clip0_12318_111384)">
        <path
          className={className}
          d="M5.36331 12.0024L3.637 4.89309L8.77868 0.15625L13.9122 4.89309L12.186 12.0024H5.36331ZM6.35763 10.7392H11.1917L12.5082 5.32383L9.41026 2.46067V5.19436C9.59594 5.30776 9.74493 5.45751 9.85721 5.64362C9.96949 5.82986 10.0256 6.0385 10.0256 6.26951C10.0256 6.61183 9.90338 6.90523 9.65889 7.14972C9.41426 7.39422 9.12086 7.51646 8.77868 7.51646C8.43103 7.51646 8.13496 7.39422 7.89047 7.14972C7.64598 6.90523 7.52373 6.61183 7.52373 6.26951C7.52373 6.0385 7.57987 5.82853 7.69215 5.63962C7.80444 5.45071 7.95608 5.30229 8.1471 5.19436V2.46067L5.04921 5.32383L6.35763 10.7392ZM2.46289 16.1562L2.89363 14.9173C2.9951 14.615 3.17166 14.3734 3.42331 14.1927C3.67482 14.0119 3.95875 13.9215 4.2751 13.9215H13.2823C13.5986 13.9215 13.8825 14.0119 14.134 14.1927C14.3857 14.3734 14.5623 14.615 14.6637 14.9173L15.0945 16.1562H2.46289Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_12318_111384">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
